// Insurance gate, same mechanism as financeAccess.js: an explicit UPN allowlist
// checked against account.username, lowercased.
//
// The insurance dash shows policy numbers, home and garaging addresses, and the
// auto ID cards: Marc and Angela, the two drivers and named insureds. The list
// is its own so that granting Finance (or taking it away) never silently
// changes who sees the household's policies.
//
// This decides what the APP shows. Whether an account can read the
// Household_Policies list and the vault files is SharePoint's call.
export const INSURANCE_ACCESS_ALLOWLIST = [
  'marc@defineholy.com',
  'marc@myfiginsurance.com',
  'angela@defineholy.com',
];

export function userHasInsuranceAccess(account) {
  if (!account || !account.username) return false;
  return INSURANCE_ACCESS_ALLOWLIST.includes(account.username.toLowerCase());
}
